import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import pick from 'lodash/pick';
import classes from './Title.module.scss';

const { Title } = Typography;

export default (props) => {
  const { className, ...restProps } = props;

  return (
    <Title
      className={cn(classes.title, className)}
      level={4}
      {...pick(restProps, ['children', 'style', 'level'])}
    />
  );
};
